import React from 'react';

import { orderBy } from 'lodash';
import { Link } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { QueryResponse } from 'api/queries/getTagsPerContract.query';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { Pills } from 'components/common/pills/pills';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import { CustomizedRoundIcon, CustomizedTooltip } from 'components/common';
import classes from 'components/widgets/RenderLibraryTable/components/ProgramTags/programTags.module.scss';

interface Props {
    list?: QueryResponse[];
}

export const ProgramTags = ({ list }: Props) => {
    return (
        <div className={classes.container}>
            Program Tags:{' '}
            {orderBy(list, [(item) => item.name.toLowerCase()], ['asc'])?.map((item) => (
                <Pills key={item.id} type={'tag'}>
                    {item.name}
                </Pills>
            ))}
            <CustomizedTooltip
                tooltipContent={'Edit Tags'}
                triggerElement={
                    <Link
                        to={AppRoutes.buildPath(
                            AppRoutes.DASHBOARD_PLANNING_PATH,
                            executionConfig.programLibrary.link,
                            executionConfig.subProgramPreferences.link,
                        )}
                    >
                        <CustomizedRoundIcon data-testid={'edit-tags'} size={'36px'}>
                            <MuiIcon icon={'edit'} fontSize={'18px'} />
                        </CustomizedRoundIcon>
                    </Link>
                }
            />
        </div>
    );
};
